import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: { marginBottom: 30 },
  header: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  iconButton: { marginRight: '34px' }
}))
export default useStyles
